import { darken, lighten, PaletteOptions } from '@mui/material';

export const DEFAULT_PRIMARY_COLOR = '#F85A40';

const COMMON = {
  white: '#FFFFFF',
  black: '#000000',
};

const PRIMARY = {
  light: lighten(DEFAULT_PRIMARY_COLOR, 0.3),
  main: DEFAULT_PRIMARY_COLOR,
  dark: darken(DEFAULT_PRIMARY_COLOR, 0.3),
};

const INFO = {
  light: '#7198FB',
  main: '#4371F9',
  dark: '#3056D6',
};
const SUCCESS = {
  light: '#6DE699',
  main: '#40D686',
  dark: '#2EB87C',
};
const WARNING = {
  light: '#FDDC61',
  main: '#FCCC2D',
  dark: '#D8A920',
};
const ERROR = {
  light: '#FE6868',
  main: '#F93939',
  dark: '#D31E1E',
};

const GREY = {
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#EBEEF2',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#2C3540',
  800: '#212B36',
  900: '#161C24',
};

const SHARED = {
  common: { black: COMMON.black, white: COMMON.white },
  primary: { ...PRIMARY, contrastText: COMMON.white },
  info: { ...INFO, contrastText: COMMON.white },
  success: { ...SUCCESS, contrastText: GREY[800] },
  warning: { ...WARNING, contrastText: GREY[800] },
  error: { ...ERROR, contrastText: COMMON.white },
  grey: GREY,
};

export const palette: { light: PaletteOptions; dark: PaletteOptions } = {
  light: {
    ...SHARED,
    mode: 'light',
    text: { primary: GREY[800], secondary: GREY[700], disabled: GREY[500] },
    background: { paper: GREY[200], default: GREY[100] },
  },
  dark: {
    ...SHARED,
    mode: 'dark',
    text: { primary: GREY[100], secondary: GREY[400], disabled: GREY[600] },
    background: { paper: GREY[800], default: GREY[900] },
  },
} as const;
